import {LOGIN} from 'modules/Common/reducers/skysso';
import {showNotification} from '../reducers/reducer';
import { has } from 'utils/features';
import LocalStorage from 'localStorage';

const INSIDER_LOGIN_STORAGE_KEY = 'shown_insider_notification';

let localStorage = new LocalStorage();
export const setLocalStorageClient = client => {
  localStorage = client;
}

export const insiderLogin = store => next => action => {
    if (has("insider-benefits") && action.type === LOGIN) {
        const state = store.getState();
        const {
            insider: {
                loginInitiated = false
            } = {}
        } = state;

        const previouslyShownNotification = localStorage.getValue(INSIDER_LOGIN_STORAGE_KEY, false);
        
        if (loginInitiated && !previouslyShownNotification) {
            localStorage.setValue(INSIDER_LOGIN_STORAGE_KEY, true);
            store.dispatch(showNotification());
        }
    }

    return next(action);
}


// WEBPACK FOOTER //
// ./modules/Insider/middleware/insiderLogin.js